import type {
  BoardMemberData,
  ExecutiveData,
  QuoteMetadata,
} from "~types/types";

const BOARD_MEMBERS_COUNT = 3;

const getPersonJson = (
  name: string,
  jobTitle?: string,
  companyName?: string,
  imageUrl?: string
) => {
  const personData = {
    "@context": "https://schema.org",
    "@type": "Person",
    name,
    jobTitle: jobTitle || null,
    worksFor: companyName || null,
    image: imageUrl
      ? {
          "@type": "ImageObject",
          url: imageUrl,
        }
      : undefined,
  };

  return personData;
};

const getEmployeeData = (
  executives: ExecutiveData[],
  boardMembers: BoardMemberData[]
) => {
  const executivesJson = executives
    .slice(0, BOARD_MEMBERS_COUNT)
    .map((person: ExecutiveData) =>
      getPersonJson(
        person.name,
        person.currentPosition,
        person.companyName,
        person.thumbnail?.src
      )
    );
  const boardMembersJson = boardMembers
    .slice(0, BOARD_MEMBERS_COUNT)
    .map((person: ExecutiveData) =>
      getPersonJson(
        person.name,
        undefined,
        person.companyName,
        person.thumbnail?.src
      )
    );

  return [...executivesJson, ...boardMembersJson];
};

export const getOrganizationJsonLd = (metadata: QuoteMetadata) => {
  const { company, displayName, shortTickerId, shortExchange } = metadata;

  const {
    boardMembers = [],
    companyDescription,
    companyIsPrivate,
    companyPhone,
    companyWebsite,
    companyAddress,
    executives = [],
    foundedYear,
    numberOfEmployees,
  } = company || {};
  const employee = getEmployeeData(executives, boardMembers);

  return {
    "@context": "https://schema.org",
    "@type": companyIsPrivate ? "Organization" : "Corporation",
    name: displayName,
    description: companyDescription,
    address: companyAddress,
    telephone: companyPhone,
    foundingDate: foundedYear,
    url: companyWebsite,
    numberOfEmployees,
    employee,
    tickerSymbol: !companyIsPrivate
      ? `${shortExchange} ${shortTickerId}`
      : undefined,
  };
};
